<!-- The header (with its close button) always renders: on phones this dialog
     is full-screen, so hiding everything left a gray screen with no way out. -->
<div class="expanded-player">

  <!-- Header -->
  <div class="player-header">
    <h2 mat-dialog-title>Now Playing</h2>
    <button mat-icon-button (click)="closeDialog()" class="close-button" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Nothing playing -->
  <div class="nothing-playing" *ngIf="!hasTrack">
    <mat-icon class="nothing-playing-icon">music_off</mat-icon>
    <p>Nothing is playing right now.</p>
    <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
  </div>

  <!-- Main Content -->
  <div class="player-content" *ngIf="hasTrack">
    
    <!-- Album Artwork -->
    <div class="album-section">
      <div class="album-art">
        <img *ngIf="getAlbumImage(); else noArtwork"
             [src]="getAlbumImage()"
             [alt]="currentTrack?.album?.name"
             class="album-image">
        <ng-template #noArtwork>
          <div class="no-artwork">
            <mat-icon>music_note</mat-icon>
          </div>
        </ng-template>
        <app-track-rating-button appearance="overlay" [track]="currentTrack"></app-track-rating-button>
      </div>
    </div>

    <!-- Track Info and Controls -->
    <div class="info-controls-section">
      
      <!-- Track Information -->
      <div class="track-info">
        <h3 class="track-name">{{ currentTrack?.name }}</h3>
        <p class="artist-name">{{ getArtistNames() }}</p>
        <p class="album-name" *ngIf="currentTrack?.album?.name">
          {{ currentTrack?.album?.name }}
        </p>
      </div>

      <!-- Progress Section -->
      <div class="progress-section">
        <span class="time-current">{{ formatTime(progress) }}</span>
        
        <mat-slider class="progress-slider"
                    [min]="0"
                    [max]="100"
                    [step]="0.1"
                    [disabled]="duration <= 0">
          <input matSliderThumb
                 [value]="getProgressPercentage()"
                 (input)="onSeekChange($event)"
                 (change)="onSeekEnd($event)">
        </mat-slider>
        
        <span class="time-total">{{ formatTime(duration) }}</span>
      </div>

      <!-- Main Controls -->
      <div class="main-controls">
        <button mat-icon-button
                matTooltip="Previous track"
                (click)="previousTrack()"
                class="control-button">
          <mat-icon>skip_previous</mat-icon>
        </button>

        <button mat-fab 
                [class.playing]="isPlaying"
                matTooltip="{{ isPlaying ? 'Pause' : 'Play' }}"
                (click)="togglePlay()"
                class="play-button">
          <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
        </button>

        <button mat-icon-button 
                matTooltip="Next track"
                (click)="nextTrack()"
                class="control-button">
          <mat-icon>skip_next</mat-icon>
        </button>

        <button mat-icon-button 
                [class.active]="repeatMode > 0"
                [matTooltip]="getRepeatTooltip()"
                (click)="toggleRepeat()"
                class="mode-button">
          <mat-icon>{{ getRepeatIcon() }}</mat-icon>
        </button>

        <button mat-icon-button 
                matTooltip="Cast to device"
                (click)="openDeviceSelector()"
                class="cast-button"
                [class.active]="hasOtherDevices">
          <mat-icon>cast</mat-icon>
        </button>
      </div>

      <!-- AI Controls -->
      <div class="ai-controls" *ngIf="canShowGenerateSimilar">
        <button mat-raised-button
                color="accent"
                [matTooltip]="contextPlaylistIsDynamic ? 'Regenerate this dynamic playlist with similar songs' : 'Generate Dynamic Playlist with similar songs'"
                (click)="generateSimilarPlaylist()"
                class="ai-button">
          <mat-icon>psychology</mat-icon>
          {{ contextPlaylistIsDynamic ? 'Regenerate' : 'Generate Similar Playlist' }}
        </button>
      </div>

      <!-- Volume Control -->
      <div class="volume-section">
        <mat-icon class="volume-icon">volume_up</mat-icon>
        
        <mat-slider class="volume-slider"
                    [min]="0"
                    [max]="100"
                    [step]="1">
          <input matSliderThumb 
                 [value]="volume * 100"
                 (input)="onVolumeInput($event)"
                 (change)="onVolumeChange($event)">
        </mat-slider>
      </div>
    </div>
  </div>
</div>